<template>
  <div v-if="overlay.length > 0" class="modal fade disclosure-overlay" :id="`disclosure-overlay-${overlay[0].overlay_type}`" tabindex="-1" :aria-labelledby="`disclosure-overlay-label-${overlay[0].id}`" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" :id="`disclosure-overlay-label-${overlay[0].overlay_type}`" v-html="disclosureTitle"></h5>
        </div>
        <div class="modal-body" v-html="disclosureText">
        </div>
        <div class="modal-footer">
          <div type="button" class="btn btn-success" v-html="disclosureButtonText" @click="closeOverlay"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bootstrap from 'bootstrap/dist/js/bootstrap.min.js'
import { mapState, mapGetters, mapMutations } from 'vuex'
export default {
  name: 'PreSciptOverlay',
  props: ['overlayType'],
  data () {
    return {
      hasAccepted: false
    }
  },
  mounted () {
    this.initModal()
  },
  methods: {
    mapText (text) {
      var consumerFields = [{ mappingText: '__agent_id__', fieldName: 'agent_id' }]
      consumerFields.forEach((f) => {
        if (this.consumer[f.fieldName]) {
          text = text.replace(new RegExp(f.mappingText, 'g'), this.consumer[f.fieldName])
        }
      })

      const leadFields = [['__consumer_phone__', 'phone1'],
        ['__consumer_name__', 'fullname'],
        ['__consumer_email__', 'email'],
        ['__consumer_firstname__', 'firstname'],
        ['__consumer_lastname__', 'lastname'],
        ['__agent_id__', 'agent_id'],
        ['__agent_name__', 'agent_name'],
        ['__call_center_dba__', 'call_center_dba'],
        ['__consumer_address__', 'address'],
        ['__consumer_city__', 'city'],
        ['__consumer_state__', 'state'],
        ['__consumer_zip__', 'zip']]
      if (this.leadInfo) {
        leadFields.forEach((item) => {
          text = text.replace(new RegExp(item[0], 'g'), this.leadInfo[item[1]] ?? '')
        })
      }
      return text
    },
    async initModal () {
      await new Promise((resolve) => setTimeout(resolve, 100))
      if (this.overlay[0]) {
        const overlayType = this.overlay[0].overlay_type
        if (!this.hasDisplayedType(overlayType)) {
          this.modal = new bootstrap.Modal(document.getElementById(`disclosure-overlay-${overlayType}`), { backdrop: 'static', keyboard: false })
          this.modal.toggle()
          var backdrops = document.querySelectorAll('.modal-backdrop')
          backdrops.forEach((backdrop) => {
            backdrop.classList.add('disclosure')
          })
          this.setDisplayed(overlayType)
        }
      } else {
        this.initModal()
      }
    },
    closeOverlay () {
      document.querySelectorAll('.modal-backdrop').forEach((backdrop) => {
        backdrop.classList.remove('disclosure')
      })
      this.modal.toggle()
    },
    ...mapMutations({
      setDisplayed: 'consumer/addDisplayedDisclosure'
    })
  },
  computed: {
    overlay () {
      return this.overlayDisclosures?.filter((ol) => ol.overlay_type === this.overlayType) ?? []
    },
    hasOverlay () {
      return this.overlay.length > 0
    },
    showOverlay () {
      if (this.consumer) {
        return this.hasOverlay && !this.hasAccepted
      }
      return false
    },
    disclosureTitle () {
      return this.consumer && this.hasOverlay && this.overlay[0].title ? this.mapText(this.overlay[0].title) : null
    },
    disclosureText () {
      return this.consumer && this.hasOverlay && this.overlay[0].text ? this.mapText(this.overlay[0].text) : null
    },
    disclosureButtonText () {
      return this.consumer && this.hasOverlay && this.overlay[0].button_text ? this.mapText(this.overlay[0].button_text) : null
    },
    ...mapState({
      consumer: state => state.consumer.currentConsumer,
      overlayDisclosures: state => state.consumer.overlayDisclosures
    }),
    ...mapGetters({
      hasDisplayedType: 'consumer/hasDisplayedOverlayDisclosure',
      leadInfo: 'consumer/lead/leadInfo'
    })
  }
}
</script>

<style lang="scss">
.disclosure.modal-backdrop.show {
  background-color: black;
  opacity: 0.85;
}
</style>
